// @flow

import React, { Component } from 'react';
import { Input, notification } from 'antd';
import { Link } from 'view/common';
import cx from 'classnames';
import './style.scss';

type Props = {}
type State = {
  email: string,
  password: string,
}

class Welcome extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      email: this.getInitialInputState(),
      password: this.getInitialInputState(),
    };
  }

  getInitialInputState = () => ({ value: '', hasError: false });

  handleInput = (e) => {
    const { value, name } = e.target;
    this.setState({
      [name]: { hasError: false, value },
    });
  };

  checkIsValidForm = () => ['email', 'password']
    .reduce((isValidForm, field) => {
      const hasError = this.state[field].value.trim() === '';
      this.setState(state => ({
        [field]: {
          ...state[field],
          hasError,
        },
      }));
      return !hasError && isValidForm;
    }, true);

  submit = () => {
    this.checkIsValidForm();
    notification['error']({
      message: 'Error!',
      description: 'The email or password you entered is incorrect.',
    });
  };

  render() {
    const { email, password } = this.state;
    return (
      <div className="welcome">
        <h1>Welcome to BandwidthFinder!</h1>
        <Input
          name="email"
          placeholder="Email Address"
          value={email.value}
          onChange={this.handleInput}
          size="large"
          className={cx(null, {
            error: email.hasError,
          })}
        />
        <Input
          name="password"
          type="password"
          placeholder="Password"
          value={password.value}
          onChange={this.handleInput}
          size="large"
          className={cx(null, {
            error: password.hasError,
          })}
        />
        <div className="loginBlock">
          <Link to="/?EarlyAccess#notify">Apply to be apart of Early Access</Link>
        </div>
        <button type="button" onClick={this.submit}>Login</button>
      </div>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/view/screens/Welcome/Welcome.jsx